module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0